import { styled } from '@mui/system';

export const DialogOverlay = styled('div')({
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: '1000 !important',
  padding: 0,
});

export const DialogWrapper = styled('div')<{ width: string }>(({ width }) => ({
  backgroundColor: '#fff',
  width,
  padding: 0,
  borderRadius: '8px',
  boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
  position: 'relative',
  margin: '4px',
}));

export const DialogContent = styled('div')({});

export const CloseButton = styled('button')({
  position: 'absolute',
  top: '10px',
  right: '10px',
  background: 'none',
  border: 'none',
  fontSize: '20px',
  cursor: 'pointer',
});
